import { RESET_DELETE_USER } from '../types'
export const resetdeleteuser = () => {

    return (dispatch) => {
        dispatch({ type: RESET_DELETE_USER });
    }
}